function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeWidth: 2,
  fill: "currentColor",
  stroke: "currentColor"
}, React.createElement("polygon", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  points: "21,9 27,3 28,10 "
}), React.createElement("polygon", {
  fill: "currentColor",
  points: "21,9 27,3 28,10 ",
  "data-stroke": "none",
  stroke: "none",
  strokeLinecap: "butt"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  d: "M3,16C3,8.82,8.82,3,16,3 c3.493,0,6.665,1.378,9.001,3.62",
  strokeLinecap: "butt"
}), React.createElement("polygon", {
  fill: "none",
  strokeMiterlimit: 10,
  points: "11,23 5,29 4,22 ",
  "data-color": "color-2"
}), React.createElement("polygon", {
  points: "11,23 5,29 4,22 ",
  "data-color": "color-2",
  "data-stroke": "none",
  stroke: "none",
  strokeLinecap: "butt"
}), React.createElement("path", {
  fill: "none",
  strokeMiterlimit: 10,
  d: "M29,16c0,7.18-5.82,13-13,13 c-3.493,0-6.665-1.378-9.001-3.62",
  "data-color": "color-2",
  strokeLinecap: "butt"
}));

var SvgRotate = function SvgRotate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRotate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rotate.5c98fc4a.svg";
export { ForwardRef as ReactComponent };